(function () {
  var currencyFormatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

  function formatCents(cents) {
    return currencyFormatter.format((cents || 0) / 100);
  }

  function getQuantity(container) {
    var form = container.closest('form') || document.querySelector('.js-product-form');
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function updateTotal(container) {
    var qty = getQuantity(container);
    var basePrice = parseInt(container.getAttribute('data-base-price'), 10) || 0;
    var baseCompare = parseInt(container.getAttribute('data-base-compare-price'), 10) || basePrice;

    var total = basePrice;
    var compareTotal = baseCompare;

    container.querySelectorAll('[data-bundle-checkbox]:checked').forEach(function (checkbox) {
      total += parseInt(checkbox.getAttribute('data-addon-price'), 10) || 0;
      compareTotal += parseInt(checkbox.getAttribute('data-addon-compare-price'), 10) || 0;
    });

    total *= qty;
    compareTotal *= qty;

    var totalEl = container.querySelector('[data-bundle-total]');
    if (totalEl) totalEl.textContent = formatCents(total);

    var compareRow = container.querySelector('[data-bundle-compare-row]');
    var compareTotalEl = container.querySelector('[data-bundle-compare-total]');
    var badgeEl = container.querySelector('[data-bundle-discount-badge]');
    if (compareRow && compareTotalEl && badgeEl) {
      if (compareTotal > total) {
        compareTotalEl.textContent = formatCents(compareTotal);
        var pct = Math.round(100 - (total / compareTotal) * 100);
        badgeEl.textContent = '-' + pct + '%';
        compareRow.hidden = false;
      } else {
        compareRow.hidden = true;
      }
    }

    var anyAddonChecked = false;

    container.querySelectorAll('[data-bundle-checkbox]').forEach(function (checkbox) {
      var item = checkbox.closest('.bundle-option__item');
      if (item) {
        if (checkbox.checked) {
          item.classList.add('is-selected');
          anyAddonChecked = true;
        } else {
          item.classList.remove('is-selected');
        }
      }
    });

    // The fixed main-product row is the de facto active choice whenever no addon is
    // checked yet; as soon as an addon is checked, the highlight moves to the addon.
    var fixedItem = container.querySelector('.bundle-option__item--fixed');
    if (fixedItem) {
      fixedItem.classList.toggle('is-selected', !anyAddonChecked);
    }
  }

  function initBundleOptions() {
    document.querySelectorAll('[data-bundle-option]').forEach(function (container) {
      if (container.dataset.bundleOptionInitialized) return;
      container.dataset.bundleOptionInitialized = 'true';

      updateTotal(container);

      container.querySelectorAll('[data-bundle-checkbox]').forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          updateTotal(container);
        });
      });

      // Clicking anywhere on the fixed main-product row resets the selection back to
      // "just the set": uncheck every addon so the highlight jumps back to this row.
      var fixedItem = container.querySelector('.bundle-option__item--fixed');
      if (fixedItem) {
        fixedItem.setAttribute('role', 'button');
        fixedItem.setAttribute('tabindex', '0');

        var resetToFixed = function () {
          var anyChecked = false;
          container.querySelectorAll('[data-bundle-checkbox]:checked').forEach(function (checkbox) {
            checkbox.checked = false;
            anyChecked = true;
          });
          if (anyChecked) updateTotal(container);
        };

        fixedItem.addEventListener('click', resetToFixed);
        fixedItem.addEventListener('keydown', function (evt) {
          if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
            evt.preventDefault();
            resetToFixed();
          }
        });
      }

      var form = container.closest('form') || document.querySelector('.js-product-form');
      var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
      if (qtyInput) {
        ['change', 'input'].forEach(function (evt) {
          qtyInput.addEventListener(evt, function () {
            updateTotal(container);
          });
        });
      }
    });
  }

  function refreshCart() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      cartDrawer.refresh(true);
    } else if (window.theme && window.theme.routes && window.location.pathname === window.theme.routes.cart) {
      window.location.reload();
    }
  }

  function resetSubmitButton(submitBtn, success) {
    if (!submitBtn) return;
    submitBtn.classList.remove('is-loading');
    submitBtn.removeAttribute('aria-disabled');
    if (success) {
      submitBtn.classList.add('is-success');
      setTimeout(function () {
        submitBtn.classList.remove('is-success');
      }, 1400);
    }
  }

  function handleBundleSubmit(evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('js-product-form')) return;

    var container = document.querySelector('[data-bundle-option]');
    if (!container) return;

    var checkedBoxes = container.querySelectorAll('[data-bundle-checkbox]:checked');
    if (!checkedBoxes.length) return; // no addon selected, let the normal single-item flow run

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var mainVariantId = idInput ? parseInt(idInput.value, 10) : 0;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    if (!mainVariantId) return;

    // Take over the submit entirely so product-form.js never also runs for this submission.
    evt.preventDefault();
    evt.stopPropagation();
    if (typeof evt.stopImmediatePropagation === 'function') evt.stopImmediatePropagation();

    var submitBtn = form.querySelector('[name="add"]');
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('is-loading');
    }

    var items = [{ id: mainVariantId, quantity: qty }];
    checkedBoxes.forEach(function (checkbox) {
      var addonId = parseInt(checkbox.getAttribute('data-addon-variant-id'), 10);
      if (addonId) {
        items.push({
          id: addonId,
          quantity: qty,
          properties: { _bundle: 'bundle-' + Date.now() }
        });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error((data && (data.description || data.message)) || 'cart/add.js failed with ' + response.status);
          });
        }
        return response.json();
      })
      .then(function () {
        refreshCart();
        resetSubmitButton(submitBtn, true);
      })
      .catch(function (error) {
        console.error('bundle-option: failed to add bundle to cart', error);
        resetSubmitButton(submitBtn, false);
      });
  }

  // Registered on document in the CAPTURE phase so this runs before product-form.js's own
  // submit listener (which is attached directly on the form in the bubble phase). A capture
  // listener on an ancestor always fires before a bubble listener on the target, regardless of
  // script load order, so calling stopPropagation() here reliably prevents the default
  // single-item add-to-cart flow from also firing when a bundle addon is selected.
  document.addEventListener('submit', handleBundleSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleOptions);
  } else {
    initBundleOptions();
  }

  document.addEventListener('shopify:section:load', initBundleOptions);
})();
